import { createSelector } from "reselect";

export const getIsbns = state => state.books.jigsaw.books.allIsbns;
export const getTotalBooks = state => getIsbns(state).length;
export const getNormalizedBooks = state => state.books.jigsaw.books.byIsbn;
export const getBookByIsbn = (state, isbn) =>
  state.books.jigsaw.books.byIsbn[isbn];

export const getBooksByIsbn = (state, isbns) => {
  return isbns.map(i => state.books.jigsaw.books.byIsbn[i]).filter(f => !!f);
};

export const isLicensedBook = (state, isbn) => {
  const book = getBookByIsbn(state, isbn);
  return !!(book && book.hasLicense);
};

export const isLoading = state => state.books.jigsaw.isLoading;
export const finishedLoading = state => state.books.jigsaw.finishedLoading;
export const getExpiredLoadStatus = state =>
  state.books.jigsaw.expiredLoadStatus;

export const getBooks = createSelector(
  [getIsbns, getNormalizedBooks],
  (isbns, books) => isbns.map(isbn => books[isbn])
);

/**
 * All expired content returned from jigsaw, no filtering
 */
export const getAllExpiredIsbns = state =>
  state.books.jigsaw.books.allExpiredIsbns;

export const getExpiredStoreBooks = createSelector(
  state => getAllExpiredIsbns(state),
  state => getNormalizedBooks(state),
  (isbns, normalizedBooks) =>
    isbns
      .map(isbn => normalizedBooks[isbn])
      .filter(
        book =>
          book.intendedUses &&
          // intentionally different from getExpiringStorePurchases
          (book.intendedUses.includes("code-api") ||
            book.intendedUses.includes("vst store"))
      )
);

const getExpirationDays = book => {
  const expirationDate = new Date(book.expiresAt);
  const expirationMS = expirationDate.valueOf() - Date.now();
  const expirationDays = expirationMS / (1000 * 60 * 60 * 24);
  if (expirationDays < 0) {
    return -1;
  }
  return Math.floor(expirationDays);
};

export const getExpiringStorePurchases = createSelector(
  state => getBooks(state),
  books => {
    return books.filter(book => {
      const expirationDays = getExpirationDays(book);
      return (
        book.intendedUses &&
        // intentionally different from getExpiredStoreBooks
        book.intendedUses.includes("vst store") &&
        expirationDays >= 0 &&
        expirationDays <= 4
      );
    });
  }
);
